import { render, staticRenderFns } from "./BoxAvos.vue?vue&type=template&id=01edb55e&"
import script from "./BoxAvos.vue?vue&type=script&lang=js&"
export * from "./BoxAvos.vue?vue&type=script&lang=js&"
import style0 from "./BoxAvos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports